module.exports = __webpack_public_path__ + "img/sunrover-tours-001-rs.99dab371.png";